import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../../shared/components/notifications/notification.service';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmDialogComponent } from '../../../../shared/components/delete-confirm-dialog/delete-confirm-dialog.component';
import { CaseForListing } from '../../../../core/models/case/case-for-listing.model';
import { CaseService } from '../../../../core/services/case.service';
import { CaseRequestFilter } from '../../../../core/models/case/case-request-filter.model';
import { AttachmentOverviewDto2 } from '../../../../core/models/attachments/attachment-overview-2.model';
import { AttachmentsModalComponent } from '../../../../shared/components/attachments-modal/attachments-modal.component';

@Component({
  selector: 'app-case-list',
  standalone: false,

  templateUrl: './case-list.component.html',
  styleUrl: './case-list.component.css'
})

export class CaseListComponent implements OnInit {
  cases: CaseForListing[] = [];
  isLoading = false;

  currentPage = 0;
  pageSize = 10;
  totalItems = 0;

  searchTerm: string | undefined = undefined;

  constructor(
    private caseService: CaseService,
    private notificationService: NotificationService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    const savedSearch = sessionStorage.getItem('cases.list.search');
    const savedPage = sessionStorage.getItem('cases.list.page');
    const savedPageSize = sessionStorage.getItem('cases.list.pageSize');

    this.searchTerm = savedSearch !== null ? (savedSearch || undefined) : this.searchTerm;
    this.currentPage = savedPage !== null ? parseInt(savedPage, 10) || 0 : this.currentPage;
    this.pageSize = savedPageSize !== null ? parseInt(savedPageSize, 10) || this.pageSize : this.pageSize;

    this.loadCases();
  }

  loadCases(): void {
    this.isLoading = true;
    const apiPage = this.currentPage + 1;

    const filter: CaseRequestFilter = {
      page: apiPage,
      pageSize: this.pageSize,
      ...(this.searchTerm !== undefined && { search: this.searchTerm })
    };

    this.caseService.getPaginatedCases(filter).subscribe({
      next: ({ data, pagination }) => {
        this.cases = data;
        this.totalItems = pagination.totalItems;
        this.pageSize = pagination.itemsPerPage;
        this.currentPage = pagination.currentPage - 1;
        this.isLoading = false;
      },
      error: () => {
        this.notificationService.showError('Failed to load cases');
        this.isLoading = false;
      }
    });
  }

  onSearchChange(): void {
    this.currentPage = 0;
    sessionStorage.setItem('cases.list.search', this.searchTerm || '');
    sessionStorage.setItem('cases.list.page', this.currentPage.toString());
    sessionStorage.setItem('cases.list.pageSize', this.pageSize.toString());
    this.loadCases();
  }

  clearSearch(): void {
    this.searchTerm = undefined;
    this.currentPage = 0;
    sessionStorage.removeItem('cases.list.search');
    sessionStorage.setItem('cases.list.page', this.currentPage.toString());
    sessionStorage.setItem('cases.list.pageSize', this.pageSize.toString());
    this.loadCases();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    sessionStorage.setItem('cases.list.page', this.currentPage.toString());
    sessionStorage.setItem('cases.list.pageSize', this.pageSize.toString());
    this.loadCases();
  }

  deleteCase(id: number): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '400px',
      data: { itemName: 'this case' }
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.caseService.softDeleteCase(id).subscribe({
          next: () => {
            this.notificationService.showSuccess('Case deleted successfully');
            this.loadCases();
          },
          error: () => this.notificationService.showError('Failed to delete case')
        });
      }
    });
  }
  openAttachmentsModal(attachments: AttachmentOverviewDto2[], caseItem: CaseForListing): void {
    const dialogRef = this.dialog.open(
      AttachmentsModalComponent,
      {
        width: '800px',
        data: attachments
      }
    );
    if (dialogRef.componentInstance) {
      dialogRef.componentInstance.caseId = caseItem.id;
      dialogRef.componentInstance.attachmentType = 'Case';
    }
    dialogRef.afterClosed().subscribe(() => {
      const modalInstance = dialogRef.componentInstance;
      if (modalInstance && modalInstance.attachments) {
        caseItem.attachments = modalInstance.attachments;
      }
    });
  }
}
